export default __webpack_public_path__ + "static/media/rectangleGroupTopRight.4d3efa6a.svg";